import { createABT } from '@common/abt';

/** ABT 키: 재키 테스터 그룹 */
export const ZACKEY_ABT_KEY = 'ab_zackey_tester' as const;
/** ABT 그룹 타입 */
export const ZACKEY_ABT_GROUP_TYPES = ['A', 'B'] as const;

/** FeatureToggle 키: 재키 피쳐 토글 */
export const ZACKEY_FEATURE_TOGGLE_KEY = 'zackey_feature_toggle' as const;
/** FeatureToggle 그룹 타입 */
export const ZACKEY_FEATURE_TOGGLE_GROUP_TYPES = ['on', 'off'] as const;

export const ZackeyAgentABT = createABT(ZACKEY_ABT_KEY, ZACKEY_ABT_GROUP_TYPES as ['A', 'B']);

export const ZackeyAgentFeatureToggle = createABT(
  ZACKEY_FEATURE_TOGGLE_KEY,
  ZACKEY_FEATURE_TOGGLE_GROUP_TYPES as ['on', 'off'],
);
